import React from 'react'
import { connect } from 'react-redux'
import Alert from '../../../../itrust_common/components/Alert'
import { humanize } from '../../../../itrust_common/components/HelperFunctions'
import { orderUpdate } from '../../../../redux/actions/order/orderActions'
import { claimFormLoad, claimFormLoadById } from '../../../../redux/actions/order/claimFormActions'
import { visionInsuranceClaimFormLoad } from '../../../../redux/actions/addOns/rpa/vision_insurance/visionInsuranceClaimFormAction'

function ClaimFormClaimType(props) {
  const { order, dispatch, claimFormData, selectedOrderInsurance, inline } = props
  const orderInsurance = order.orders_insurances_attributes?.find(
    (item) => item.id === selectedOrderInsurance?.id,
  ) || selectedOrderInsurance
  const visionInsuranceService = orderInsurance?.vision_insurance_service
  const noShowInsuranceFields = ['eyemed'].includes(visionInsuranceService?.service)
  const showClaimType = visionInsuranceService?.service
    ? (claimFormData?.id && !noShowInsuranceFields)
    : Boolean(claimFormData?.id)

  if (!showClaimType) {
    return null
  }

  const getClaimTypeDropdownOptions = (dropdownValuesObj) => {
    return dropdownValuesObj && Object.keys(dropdownValuesObj).filter((key) => dropdownValuesObj[key] === true)
  }

  const handleClaimFormReload = () => {
    if (orderInsurance?.visionary_insurance_claim_form_id) {
      dispatch(visionInsuranceClaimFormLoad(order.id, {
        include: '*',
        orders_insurance_id: orderInsurance.id,
      }))
      return
    }

    const claimFormId = orderInsurance?.claim_form_id || claimFormData?.id
    if (claimFormId) {
      dispatch(claimFormLoadById(order.id, claimFormId, { include: '*' }))
    } else {
      dispatch(claimFormLoad(order.id, { include: '*' }))
    }
  }

  const handleClaimTypeChange = async (claimType) => {
    if (!claimType) {
      Alert.warning('Please select a valid insurance claim type.')
      return
    }

    await dispatch(orderUpdate({
      id: order.id,
      orders_insurances_attributes: [{
        id: orderInsurance.id,
        claim_type: claimType,
      }],
    }, { include: '*' }))
    handleClaimFormReload()
  }

  const claimTypeOptions = getClaimTypeDropdownOptions(orderInsurance?.claim_dropdown_values)

  if (inline) {
    return (
      <div className="claim-form-modal__claim-type-inline form-group mb-0 ml-md-3">
        <label className="claim-form-modal__claim-type-label" htmlFor="claimFormInsuranceClaimType">
          Insurance Claim Type
        </label>
        <select
          className="form-control"
          value={orderInsurance?.claim_type || ''}
          id="claimFormInsuranceClaimType"
          onChange={(e) => handleClaimTypeChange(e.target.value)}
        >
          <option value="" className="text-muted">Select Claim Type</option>
          {claimTypeOptions?.map((claimType) => (
            <option key={claimType} value={claimType}>{humanize(claimType)}</option>
          ))}
        </select>
      </div>
    )
  }

  return (
    <div className="claim-form-modal__claim-type border-bottom bg-white px-7 py-3">
      <div className="form-group mb-0">
        <label htmlFor="claimFormInsuranceClaimType">Insurance Claim Type</label>
        <select
          className="form-control"
          value={orderInsurance?.claim_type || ''}
          id="claimFormInsuranceClaimType"
          onChange={(e) => handleClaimTypeChange(e.target.value)}
        >
          <option value="" className="text-muted">Select Claim Type</option>
          {claimTypeOptions?.map((claimType) => (
            <option key={claimType} value={claimType}>{humanize(claimType)}</option>
          ))}
        </select>
      </div>
    </div>
  )
}

const mapStateToProps = (state, ownProps) => {
  const {
    order: { order },
    claimForm: { insurance_claim_form },
    visionInsuranceClaimForm: { visionInsuranceClaimForm },
  } = state

  const orderInsurance = order.orders_insurances_attributes?.find(
    (item) => item.id === ownProps.selectedOrderInsurance?.id,
  )

  return {
    order,
    claimFormData: orderInsurance?.visionary_insurance_claim_form_id
      ? visionInsuranceClaimForm
      : insurance_claim_form,
  }
}

export default connect(mapStateToProps)(ClaimFormClaimType)
